import { getCurrentWallet } from '../utils/wallets-integration';
import { Transaction as WSTransaction } from '@near-wallet-selector/core';
const webWalletIds = ['my-near-wallet', 'mintbase-wallet', 'bitte-wallet'];
export async function batchDeleteKeys(publicKeys: string[]) {
  const accountId = getCurrentWallet().wallet.getAccountId();
  const wallet = await window.selector.wallet();
  const wstransactions: WSTransaction[] = [];
  const actions = [];
  publicKeys.forEach((key) => {
    actions.push({
      type: 'DeleteKey',
      params: {
        publicKey: key,
      },
    });
  });
  wstransactions.push({
    signerId: accountId,
    receiverId: accountId,
    actions,
  });
  wallet
    .signAndSendTransactions({
      transactions: wstransactions,
    })
    .then(() => {
      if (!webWalletIds.includes(wallet.id)) {
        window.location.reload();
      }
    })
    .catch(() => {
      if (!webWalletIds.includes(wallet.id)) {
        window.location.reload();
      }
    });
}
